import type { ReactNode } from "react";

type OpenToolTerminalFrameProps = {
  title?: string;
  prompt?: string;
  children: ReactNode;
  className?: string;
  compact?: boolean;
};

export function CodexTerminalFrame({
  title = "opentool",
  prompt,
  children,
  className,
  compact = false,
}: OpenToolTerminalFrameProps) {
  return (
    <section className={`opentool-terminal-frame${compact ? " is-compact" : ""}${className ? ` ${className}` : ""}`}>
      <header className="opentool-terminal-frame__chrome" aria-hidden="true">
        <div className="opentool-terminal-frame__lights">
          <span />
          <span />
          <span />
        </div>
        <strong>{title}</strong>
      </header>
      <div className="opentool-terminal-frame__body">
        {prompt ? <div className="opentool-terminal-frame__prompt">{prompt}</div> : null}
        <div className="opentool-terminal-frame__content">{children}</div>
      </div>
    </section>
  );
}
